<template>
  <v-card v-if="endUseSort" id="end-use-sort-form">
    <v-card-title class="primary white--text">
      <v-row class="pa-2" justify="space-between">
        <span class="headline">
          {{ title }}
        </span>
        <BaseDialogActions hideRefresh hideFullscreen />
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row justify="end" no-gutters>

        <v-col cols="12">
          <v-text-field
          class="pt-6"
          v-model="endUseSort.name"
          :rules="[rules.required]"
          :label="$t('name')"
          color="black"
          :counter="maxNameLength"
          :maxlength="maxNameLength"
          ref="endUseSortName"/>
        </v-col>

        <v-col cols="12">
          <v-text-field
          class="pb-6"
          v-model="endUseSort.code"
          :rules="[rules.required]"
          :label="$t('code')"
          color="black"
          :counter="maxCodeLength"
          :maxlength="maxCodeLength"/>
        </v-col>

        <v-col cols="auto">
          <v-btn id="end-use-sort-submit" color="primary" @click="submitClicked" :disabled="!canSubmit">
            {{ buttonText }}
          </v-btn>
        </v-col>

      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import fieldRules from '@/utils/rules.js'

export default {
  name: 'EndUseSortForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    propEndUseSort: {
      type: Object,
      required: false,
      default: undefined
    }
  },

  created () {
    if (this.propEndUseSort) {
      this.endUseSort = JSON.parse(JSON.stringify(this.propEndUseSort))
    }
  },

  mounted () {
    setTimeout(_ => {
      this.$refs.endUseSortName.focus()
      document.addEventListener('keyup', this.onKeyup)
    }, 0)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.onKeyup)
  },

  computed: {
    editing () {
      return this.endUseSort?.endUseSortId
    },

    title () {
      return this.editing ? this.$t('editEndUseSort') : this.$t('createNewEndUseSort')
    },

    buttonText () {
      return this.editing ? this.$t('saveChanges') : this.$t('create')
    },

    canSubmit () {
      return this.endUseSort.name.length > 0 && this.endUseSort.name.length <= this.maxNameLength &&
             this.endUseSort.code.length > 0 && this.endUseSort.code.length <= this.maxCodeLength
    }
  },

  data: () => ({
    endUseSort: {
      name: '',
      code: ''
    },
    maxNameLength: 32,
    maxCodeLength: 10,
    rules: fieldRules.rules
  }),

  methods: {
    ...mapActions('end-use-sort', ['createEndUseSort', 'updateEndUseSort']),

    async submitClicked () {
      if (this.validate() && this.canSubmit) {
        this.editing ? await this.updateEndUseSort(this.endUseSort) : await this.createEndUseSort(this.endUseSort)
        this.$emit('end-use-sort-mutated')
      }
    },

    onKeyup (e) {
      if (e.key.toLowerCase() === 'enter') {
        this.submitClicked()
      }
    },

    validate () {
      if (this.endUseSort.name.length <= 0 || this.endUseSort.name.length > this.maxNameLength) {
        this.setSnackError(this.$t('nameIsRequired'))
        return false
      }
      if (this.endUseSort.code.length <= 0 || this.endUseSort.code.length > this.maxCodeLength) {
        this.setSnackError(this.$t('codeIsRequired'))
        return false
      }
      return true
    }
  }
}
</script>
